module.exports = __webpack_public_path__ + "static/media/pause.817aafc2.svg";